import type { CookDate } from '@platewell/core';
import { formatCookDateScale, formatCookDay, madeCookDates } from '@platewell/core';
import { Dialog } from './dialog.js';

export interface CookHistoryDialogProps {
  title: string;
  cookDates: readonly CookDate[];
  onClose: () => void;
}

/**
 * Every day the recipe has been made, newest first. Read-only; the list scrolls inside
 * the dialog once it outgrows it.
 *
 * Mirrored on mobile by `apps/mobile/src/components/cook-history-sheet.tsx`; keep the two
 * in step.
 */
export function CookHistoryDialog({ title, cookDates, onClose }: CookHistoryDialogProps) {
  const made = madeCookDates(cookDates);

  return (
    <Dialog onClose={onClose} aria-label={`Times made for “${title}”`}>
      <h2>Times made</h2>
      <p className="hint">
        {made.length === 0
          ? `${title} has never been made.`
          : `${title} have been made ${made.length} ${made.length === 1 ? 'time' : 'times'}.`}
      </p>

      {made.length > 0 && (
        <ol className="cook-history-list">
          {made.map((entry) => {
            const scale = formatCookDateScale(entry);
            return (
              <li key={entry.id}>
                {formatCookDay(entry.date)}
                {scale != null && <span className="cook-history-scale">{scale}</span>}
              </li>
            );
          })}
        </ol>
      )}

      <div className="row" style={{ marginTop: 18 }}>
        <span className="spacer" />
        <button type="button" className="btn" onClick={onClose}>
          Done
        </button>
      </div>
    </Dialog>
  );
}
